import { render, staticRenderFns } from "./ReportDigest.vue?vue&type=template&id=60ae9fa2&scoped=true"
import script from "./ReportDigest.vue?vue&type=script&lang=js"
export * from "./ReportDigest.vue?vue&type=script&lang=js"
import style0 from "./ReportDigest.vue?vue&type=style&index=0&id=60ae9fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae9fa2",
  null
  
)

export default component.exports